import React from 'react';

function FloatingInput({
  ref,
  id,
  type,
  name,
  size,
  floatingText,
  maxLength,
  autoFocus,
  autoComplete,
  value,
  onChange,
  className,
  placeholder,
  error,
  onBlur,
  readOnly,
  closeIcon = false,
  onClearText,
  required = false,
  ariaRequired = false
}) {
  return (
    <>
      <label
        className={`${
          error ? 'pure-material-textfield-outlined-error' : ''
        } pure-material-textfield-outlined`}
      >
        <input
          onBlur={onBlur}
          ref={ref}
          id={id}
          type={type}
          name={name}
          size={size}
          className={`form-control ${className}`}
          maxLength={maxLength}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          placeholder={placeholder}
          required={required}
          aria-required={ariaRequired}
        />
        <span aria-label={floatingText}>{floatingText}</span>
        {/* <span class="staricon">*</span> */}
        {closeIcon && (
          <div
            className="close-button ic-close-quickview close-button-mr"
            onClick={e => {
              e.preventDefault();
              onClearText();
            }}
          />
        )}
      </label>
    </>
  );
}

export default FloatingInput;
